<template>
  <div class="slide-wrap">
    <Carousel class="slide-banner-wrap" :banners="banners"></Carousel>
  </div>
</template>
<script>
import { indexApi } from '../../api/indexApi';
import { mapGetters } from 'vuex';
import Carousel from './BannerCarousel';

export default {
  name: 'Banner',
  components: { Carousel },
  data() {
    return {
      current: 0,
      banners: [
        // {
        //   id: '1010101010101010152',
        //   name: 'Lowest Trading Fees in the World',
        //   img: require('./img/landing-bg-1.png'),
        //   smallImg: 'https://mbaex-static.oss-cn-hongkong.aliyuncs.com/static/1574823858558.jpg',
        //   linkUrl: '/ArticleDetail/5d12d74c8e8efd3298b6d1d6/notice',
        //   weight: 1,
        //   button: 'Find out more',
        //   // description: "<h1 class="slide-text"><font color="#CC1616">MBAex</font></h1>↵<h1 class="slide-title"><font color="#FFFFFF">Lowest Trading Fees in the World</font></h1>↵<h2 class="slide-title"><font color="#FFFFFF">Be Part of A Large Network and Grow Your Wealth!</font></h2>",
        //   created: '2019-07-01 11:14:05',
        //   lastUpdateTime: '2019-11-27 11:08:12',
        // },
        // {
        //   id: '10101010101010101522',
        //   name: 'Lowest Trading Fees in the World',
        //   img: require('./img/landing-bg-2.png'),
        //   smallImg: 'https://mbaex-static.oss-cn-hongkong.aliyuncs.com/static/1574823858558.jpg',
        //   linkUrl: '/ArticleDetail/5d12d74c8e8efd3298b6d1d6/notice',
        //   weight: 1,
        //   button: 'Find out more',
        //   // description: "<h1 class="slide-text"><font color="#CC1616">MBAex</font></h1>↵<h1 class="slide-title"><font color="#FFFFFF">Lowest Trading Fees in the World</font></h1>↵<h2 class="slide-title"><font color="#FFFFFF">Be Part of A Large Network and Grow Your Wealth!</font></h2>",
        //   created: '2019-07-01 11:14:05',
        //   lastUpdateTime: '2019-11-27 11:08:12',
        // },
      ]
    };
  },
  computed: {
    ...mapGetters(['Getter_Lang'])
  },
  mounted() {
    this.getIndexBanner();
  },
  methods: {
    prev() {
      const len = this.banners.length;
      if (len) {
        this.current = (this.current - 1 + len) % len;
      }
    },
    next() {
      const len = this.banners.length;
      if (len) {
        this.current = (this.current + 1) % len;
      }
    },
    // 获取首页banner数据
    getIndexBanner() {
      /*
        category: 1 web端，2 移动端
        position： index-首页，account-个人账户，referral-邀请
       */
      indexApi.getIndexBanner({ category: 1, position: 'index', lang: this.Getter_Lang.code }).then(res => {
        let data = res.data;
        if (data.banners && data.banners.length > 0) {
          for (let item of data.banners) {
            let img = JSON.parse(item.img);
            if (this.Getter_Lang.code === 'zh_CN') {
              item.imgBasedOnLang = img.zh_CN || img.en_US;
            } else if (this.Getter_Lang.code === 'zh_TW') {
              item.imgBasedOnLang = img.zh_TW || img.en_US;
            } else {
              item.imgBasedOnLang = img.en_US;
            }
          }
          this.banners = data.banners;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.slide-wrap{
  position: relative;
  height: 494px;
}

.slide-banner-wrap {
  width: 100%;
  height: 550px;
}

.slide-controller{
  position: absolute;
  bottom: 62px;
  width: 1200px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 3;
}

.slide-controller li{
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: rgba(26,31,51,.9);
  margin-right: 10px;
  cursor: pointer;
  user-select: none;
}

.slide-controller li:active{
  opacity: .8;
}

@media (min-width: 1600px){
  .slide-wrap{
    position: relative;
    height: 550px;
  }
}

@media screen and (max-width: 768px ) {
  .slide-wrap, .slide-banner-wrap {
    height: 450px;
  }
}

@media screen and (max-width: 576px ) {
  .slide-wrap, .slide-banner-wrap {
    height: 400px;
  }
}
</style>
